/**
 * Enum値の定数値を設定
 * 各コンポーネントではmixinとして呼び込む
 * なお、同名の定数値がすでに存在した場合、そちらが優先されるので注意
 */
var enumMixin = {
  data: function () {
    return {

      EnumMode01: 1,
      EnumMode02: 2,
      EnumMode03: 3,
      EnumMode04: 4,
      EnumMode05: 5

    }
  }
}

export default enumMixin
